module.exports = __webpack_public_path__ + "img/p2.e9183df1.png";